.row {
    display: flex;
    align-items: center;
    gap: var(--exo-spacing-small);
    width: 100%;
    padding: var(--exo-spacing-small) var(--exo-spacing-standard);
    background: none;
    border: none;
    border-bottom: 1px solid var(--exo-color-border-secondary);
    text-align: left;
    cursor: pointer;
    color: var(--exo-color-font);
    transition: background 0.15s;
}

.row:first-child {
    border-top: 1px solid var(--exo-color-border-secondary);
}

.row:hover {
    background: var(--exo-color-background-secondary);
}

.iconWrap {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

:global(.ex-theme-dark) .iconWrap {
    background: #f0f0f0;
    border: 1px solid rgba(0, 0, 0, 0.06);
}

.name {
    font-size: var(--exo-font-size-small);
    font-weight: 500;
    flex: 1;
}
